<style scoped>

</style>
<template>
  <div>
    <ExpensePaymentBank />
  </div>
</template>
<script route="/fin/setting">
  import ExpensePaymentBank from './components/expense_payment_bank';
  export default {
    components: { ExpensePaymentBank },
    data() {
      return {
        //
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
